
import { mapState } from 'vuex'
import { ShippingProductClick } from '@/reporter/track'
import allUrls from '@/utils/config'
import { urlEnhanceLang } from '@/utils/utils'
import link from '@/modules/config/link'
import gjUtmConfig from '@/utils/gjUtm'
import usOrder from '@/modules/templates/default/consign/components/usOrder.vue'
import { getJpBannerConfig } from '../jpBannerData'

export default {
  name: 'JpBanner',
  components: { usOrder },
  props: {
    propsData: {
      type: Object,
      default: () => ({}),
    },
    /**
     * 子产品的 code（URL 中的 detailName，如 fast / bulk / discts / delivery）
     * 用于从 jpBannerData 查找对应的背景图和提示语
     */
    detailCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      gjUtm: gjUtmConfig.sfIntlOsSs1,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      site: (state) => state.site,
      loginToken: (state) => state.loginToken,
    }),
    iuopLink() {
      return link[this.site]
    },
    isChildren() {
      return !!this.propsData.isChildren
    },
    bannerConfig() {
      return getJpBannerConfig(this.detailCode)
    },
    bgImage() {
      return this.bannerConfig.bgImage
    },
    subtitle() {
      const key = this.bannerConfig.subtitleKey
      return this.propsData.subtitle || (key ? this.$t(key) : '') || ''
    },
  },
  methods: {
    handleConsignClick() {
      const site = this.site
      if (site === 'us') {
        this.$refs.usOrderRef.openDialog()
      } else {
        this.jump()
      }
    },
    jump() {
      const { detail } = this.$route.params
      ShippingProductClick()
      if (detail === 'sfbuy') {
        window.open(allUrls.sfbuyUrl)
      } else if (detail === 'warehouse') {
        if (window.iuopWarehouseFlag) {
          const loginToken = this.loginToken
          if (loginToken) {
            const url = urlEnhanceLang({
              lang: this.locale,
              url: this.iuopLink.iuopLoginingUrl.replace('{token}', loginToken),
              gjUtm: this.gjUtm[this.site],
            })
            window.open(url)
          } else {
            const url = urlEnhanceLang({
              lang: this.locale,
              url: this.iuopLink.iuoploginUrl,
              gjUtm: this.gjUtm[this.site],
            })
            window.open(url)
          }
        } else {
          window.open(allUrls.wherpLoginUrl)
        }
      } else {
        const url = urlEnhanceLang({
          lang: this.locale,
          url: this.iuopLink.iuoploginUrl,
          gjUtm: this.gjUtm[this.site],
        })
        window.open(url)
      }
    },
  },
}
